<div class="subtitle-1 pt-2">
  {{group.name}}
</div>
<div class="caption pb-2">
  {{unitsOverview}}
</div>
